import { SetMetadata } from '@nestjs/common';
import { NEED_LOGIN_KEY } from '../const';

/**
 * NeedLogin 装饰器
 * 标记接口需要登录。如果鉴权失败（如 401/403），异常过滤器会将请求重定向到登录页。
 * 可选地传入登录页路径，默认 '/login'。
 */
export const NeedLogin = (loginPath?: string): MethodDecorator & ClassDecorator => {
  return SetMetadata(NEED_LOGIN_KEY, { loginPath });
};


